var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 42.5V38.5C38 36.3783 37.1571 34.3434 35.6569 32.8431C34.1566 31.3429 32.1217 30.5 30 30.5H18C15.8783 30.5 13.8434 31.3429 12.3431 32.8431C10.8429 34.3434 10 36.3783 10 38.5V42.5",
    stroke: "#218472",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5C28.4183 22.5 32 18.9183 32 14.5C32 10.0817 28.4183 6.5 24 6.5C19.5817 6.5 16 10.0817 16 14.5C16 18.9183 19.5817 22.5 24 22.5Z",
    stroke: "#218472",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.298edc1f1244d00e27ecef8c5920b424.svg";
export { ForwardRef as ReactComponent };